
export class PeriodoEvaluacion {
periodoevaluacionid: number = 0;
cicloid: number = 0;
ciclo: string = "";
descripcion: string = "";
fechainicioperiodo: any = "";
fechainicioacuerdos: any = "";
fechafinacuerdos: any = "";
tipoevaluacionid: number[] = [];

constructor(init?: Partial<PeriodoEvaluacion>) {
    Object.assign(this, init);
}

}
